import Api from "@root/components/api";

export default class CourseMutation {
    // course
    async updateCourse(course, subjectId, skillsets) {
        let query = `mutation ($courseId: String!, $input: CourseInput!) {
            updateCourse(courseId: $courseId, input: $input)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            courseId: course.id, 
            input: {
                courseId: course.id,
                name: course.name, 
                description: course.description, 
                published: course.published,
                seoDescription: course.seoDescription,
                telegramChannel: course.telegramChannel,
                seoKeywords: course.seoKeywords,
                subjectId: subjectId, 
                imageUrl: course.imageUrl,
                skillsets: skillsets.map(c=>c.id),
                free: course.free,
                price: +course.price,
                about: course.about,
                duration: course.duration,
                audiences: course.audiences.map(t => t.header + ":" + t.body),
                targets: course.targets.map(t => t.header + ":" + t.body),
            }
        }});
    }

    async reorderLessons(themeId, lessonIds) {
        let query = `mutation ($themeId: String!, $lessonIds: [String!]!) {
            reorderLessons(themeId: $themeId, lessonIds: $lessonIds)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            themeId: themeId,
            lessonIds: lessonIds,
        }});
    }
 
    async publish(lessonId, notifyUsers) {
        let query = `mutation ($lessonId: String!, $notifyUsers: Boolean!) {
            publishThemeLesson(lessonId: $lessonId, notifyUsers: $notifyUsers)
        }`;
        const response = await Api.postData('/g', { query: query, variables: {
            lessonId: lessonId,
            notifyUsers: notifyUsers,
        }});
        return response.data.subscribeCourse;
    }
   
    async unpublish(lessonId, notifyUsers) {
        let query = `mutation ($lessonId: String!) {
            unpublishThemeLesson(lessonId: $lessonId)
        }`;
        const response = await Api.postData('/g', { query: query, variables: {
            lessonId: lessonId
        }});
        return response.data.subscribeCourse;
    }

    async subscribe(courseId) {
        let query = `mutation ($courseId: String!) {
            subscribeCourse(courseId: $courseId, subscribe: true)
        }`;
        const response = await Api.postData('/g', { query: query, variables: {
            courseId: courseId
        }});
        return response.data.subscribeCourse;
    }

    async unsubscribe(courseId) {
        let query = `mutation ($courseId: String!) {
            subscribeCourse(courseId: $courseId, subscribe: false)
        }`;
        const response = await Api.postData('/g', { query: query, variables: {
            courseId: courseId
        }});
        return response.data.subscribeCourse;
    }
    
    // theme
    async addCourseTheme(courseId, name, x, y, from, subtype) {
        let query = `mutation ($courseId: String!, $name: String!, $x: Int!, $y: Int!, $from: [String!]!, $subtype: String) {
            addCourseTheme(courseId: $courseId, name: $name, x: $x, y: $y, from: $from, subtype: $subtype)
        }`;
        return await Api.postData('/g', { query: query, variables: { courseId: courseId, name: name, x: x, y: y, from: from, subtype: subtype } });
    }

    async updateCourseTheme(themeId, name, x, y, from) {
        let query = `mutation ($themeId: String!, $name: String!, $x: Int!, $y: Int!, $from: [String!]!) {
            updateCourseTheme(themeId: $themeId, name: $name, x: $x, y: $y, from: $from)
        }`;
        return await Api.postData('/g', { query: query, variables: { themeId: themeId, name: name, x: x, y: y, from: from } });
    }

    async removeCourseTheme(courseId, themeId) {
        let query = `mutation ($courseId: String!, $themeId: String!) {
            removeCourseTheme(courseId: $courseId, themeId: $themeId)
        }`;
        return await Api.postData('/g', { query: query, variables: { courseId: courseId, themeId: themeId } });
    }    

    async lockTheme(themeId) {
        let query = `mutation ($themeId: String!) {
            lockCourseTheme(themeId: $themeId, free: false)
        }`;
        return await Api.postData('/g', { query: query, variables: { themeId: themeId } });
    }    

    async unlockTheme(themeId) {
        let query = `mutation ($themeId: String!) {
            lockCourseTheme(themeId: $themeId, free: true)
        }`;
        return await Api.postData('/g', { query: query, variables: { themeId: themeId } });
    }    
    


    // lesson
    async addThemeLesson(themeId, name) {
        let query = `mutation ($themeId: String!, $name: String!) {
            addThemeLesson(themeId: $themeId, name: $name)
        }`;
        return await Api.postData('/g', { query: query, variables: { themeId: themeId, name: name } });
    }

    async updateThemeLesson(lessonId, name) {
        let query = `mutation ($lessonId: String!, $name: String!) {
            updateThemeLesson(lessonId: $lessonId, name: $name)
        }`;
        return await Api.postData('/g', { query: query, variables: { lessonId: lessonId, name: name } });
    }

    async removeThemeLesson($lessonId) {
        let query = `mutation ($lessonId: String!) {
            removeThemeLesson(lessonId: $lessonId)
        }`;
        return await Api.postData('/g', { query: query, variables: { lessonId: $lessonId } });
    } 



    // entry
    async addLessonEntry(lessonId, entryType, name) {
        let query = `mutation ($lessonId: String!, $entryType: String!, $name: String!) {
            addLessonEntry(lessonId: $lessonId, entryType: $entryType, name: $name)
        }`;
        return await Api.postData('/g', { query: query, variables: { lessonId: lessonId, entryType: entryType, name: name } });
    }

    async updateLessonEntry(entryId, input) {
        let query = `mutation ($entryId: String!, $input: LessonEntryInput!) {
            updateLessonEntry(entryId: $entryId, input: $input)
        }`;
        return await Api.postData('/g', { query: query, variables: { entryId: entryId, input: input } });
    }

    async removeLessonEntry(entryId) {
        let query = `mutation ($entryId: String!) {
            removeLessonEntry(entryId: $entryId)
        }`;
        return await Api.postData('/g', { query: query, variables: { entryId: entryId } });
    }

    async addTerm(entryId, skillId, videoUrl, description) {
        let query = `mutation ($entryId: String!, $skillId: String!, $videoUrl: String!, $description: String!) {
            addTerm(entryId: $entryId, skillId: $skillId, videoUrl: $videoUrl, description: $description)
        }`;
        return await Api.postData('/g', { query: query, variables: { entryId: entryId, skillId: skillId, videoUrl: videoUrl, description: description } });
    }

    async addCourseSkillsToSkillset(skillsetId, courseId) {
        let result = await Api.postData('/api/addCourseSkillsToSkillset', {skillsetId: skillsetId, courseId: courseId});
        return result;
    }

    async searchChallenges(text) {
        let query = `query ($text: String!) {
            searchChallenges(text: $text) {
                id, name, pin, joinUrl, authorId, challengeType, duration, startTime, 
                started, finished, sync, gameIndex, rules, hasChallengeScene, state,language,node, disableSwitchBrowser,reducePointsForSlowAnswer,
                penaltyForIncorrect, allowHint, allowSkip,
                primarySubject {
                    id, name
                }
                participants {
                    robot, user {
                       visualName
                    }
                }
            }
        }`;
        return await Api.postData('/g', { query: query, variables: { text: text } });
    }

    async setThemeChallenge(themeId, challengeInstanceId) {
        let query = `mutation ($themeId: String!, $challengeInstanceId: String!) {
            setThemeChallenge(themeId: $themeId, challengeInstanceId: $challengeInstanceId)
        }`;
        return await Api.postData('/g', { query: query, variables: { themeId: themeId, challengeInstanceId: challengeInstanceId } });

    }

    async createCourseChallenge(themeId) {
        let query = `mutation ($themeId: String!) {
            createCourseChallenge(themeId: $themeId) {
                joinUrl
            }
        }`;
        return await Api.postData('/g', { query: query, variables: { themeId: themeId } });

    }

    
}
